import { IRevenueSpendCrudModalLang } from '../../../types/lang'

export const revenueSpendCrudModalLang: IRevenueSpendCrudModalLang = {
	revenue_spend_crud_modal: {
		title_create: 'Create revenue spend',
		title_edit: 'Edit revenue spend',
		title_remove_single: 'Remove <span>revenue spend</span>',
		title_notes_view: 'View notes for revenue spend',
		title_notes_edit: 'Edit notes for revenue spend',
		title_history_view: 'View history in revenue spend',
		title_select_users: 'Revenue spend select users (buyers) for revenue agency',
		label_mode_revenue_cpa: 'Revenue Cpa',
		label_mode_revenue_spend: 'Revenue Spend',
		label_mode_revenue: 'Revenue',
		title_by_account_revenue: 'View revenue spend - {{mode}} - detail info by account {{account}} - {{date}}',
		title_by_account_revenue_total: 'View TOTAL revenue spend - {{mode}} - detail info',
		title_by_account_offer_spend: 'View revenue spend - Revenue Offer Spend - detail info by account {{account}} - {{date}}',
		title_by_account_offer_spend_total: 'View TOTAL revenue spend - Revenue Offer Spend - detail info',
		title_by_account_spend: 'View revenue spend - Spend - detail info by account {{account}} - {{date}}',
		title_by_account_spend_total: 'View TOTAL revenue spend - Spend - detail info',
		title_by_team_revenue: 'View revenue spend - {{mode}} - detail info by team {{team}} - {{date}}',
		title_by_team_revenue_total: 'View TOTAL revenue spend - {{mode}} - detail info',
		title_by_team_offer_spend: 'View revenue spend - Revenue Offer Spend - detail info by team {{team}} - {{date}}',
		title_by_team_offer_spend_total: 'View TOTAL revenue spend - Revenue Offer Spend - detail info',
		title_by_team_spend: 'View revenue spend - Spend - detail info by team {{team}} - {{date}}',
		title_by_team_spend_total: 'View TOTAL revenue spend - Spend - detail info',
		field_agency_label: 'Agency',
		field_agency_placeholder: 'Agency',
		field_account_label: 'Account',
		field_account_placeholder: 'Account',
		field_kt_group_label: 'KT Group',
		field_kt_group_placeholder: 'KT Group',
		field_date_label: 'Date',
		field_date_placeholder: 'Date',
		field_amount_label: 'Amount',
		field_amount_placeholder: 'Type number',
		field_notes_label: 'Notes',
		field_notes_placeholder: 'Notes',
		msg_remove_confirm: 'Are you sure?',
		btn_select_users: 'Select Users (Buyers)',
		btn_create: 'Create',
		btn_update: 'Save',
		btn_remove: 'Remove',
		btn_close: 'Close'
	}
}